import { z } from "zod";
import { create } from "zustand";

const editBuildingSchema = z.object({
  id: z.string(),
  buildingName: z.string({ message: "Enter building name" }),
  address: z.string({ message: "Enter address" }),
  letterIdBuilding: z.string({ message: "Enter letter id" }).optional(),
  buildingCity: z.string({ message: "Enter city" }),
  buildingCountry: z.string({ message: "Enter country" }),
  buildingState: z.string({ message: "Enter state" }),
  buildingZip: z.string({ message: "Enter zip" }),
});

type EditBuildingType = z.infer<typeof editBuildingSchema>;

interface SelectedBuilding {
  selectedBuilding: EditBuildingType | null;
  setSelectedBuilding: (selectedBuilding: EditBuildingType | null) => void;
}

interface selectedBuildingName {
  selectedBuildingName: string | undefined;
  setSelectedBuildingName: (selectedBuildingName: string | undefined) => void;
}

interface tempSelectedBuildingName {
  tempSelectedBuildingName: string | undefined;
  setTempSelectedBuildingName: (
    tempSelectedBuildingName: string | undefined,
  ) => void;
}

export const useTempSelectedBuildingName = create<tempSelectedBuildingName>()(
  (set) => ({
    tempSelectedBuildingName: undefined,
    setTempSelectedBuildingName: (tempSelectedBuildingName) =>
      set({ tempSelectedBuildingName }),
  }),
);

export const useSelectedBuildingName = create<selectedBuildingName>()(
  (set) => ({
    selectedBuildingName: undefined,
    setSelectedBuildingName: (selectedBuildingName) =>
      set({ selectedBuildingName }),
  }),
);

export const useSelectedState = create<SelectedBuilding>()((set) => ({
  selectedBuilding: null,
  setSelectedBuilding: (selectedBuilding) => set({ selectedBuilding }),
}));
